"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressFinderWidgetSrc = exports.ContainerPrefix = exports.Country = void 0;
var Country;
(function (Country) {
  Country["AU"] = "AU";
  Country["NZ"] = "NZ";
})(Country = exports.Country || (exports.Country = {}));
exports.ContainerPrefix = 'address-container';
exports.AddressFinderWidgetSrc = 'https://api.addressfinder.io/assets/v3/widget.js';